module.exports = __webpack_public_path__ + "images/home/product/features-list-d7bc48f028f5d92fe8de32434cd3eb51.png";